import type { Money } from "./economy";

/**
 * Per-client reputation tracker. Each unique client (named Utah company) earns
 * reputation as you complete their contracts. Higher reputation unlocks
 * premium contracts from that client and increases payout multipliers.
 */
export interface ClientReputation {
	clientId: string;
	displayName: string;
	totalContracts: number;
	failedContracts: number;
	totalRevenue: Money;
	level: number; // 0..5
	lastContractAt?: string;
}

/** Rep level thresholds (contract count). */
export const REP_THRESHOLDS = [0, 1, 5, 15, 35, 75] as const;

export function repLevelFor(totalContracts: number): number {
	let lvl = 0;
	for (let i = 0; i < REP_THRESHOLDS.length; i++) {
		if (totalContracts >= REP_THRESHOLDS[i]!) lvl = i;
	}
	return lvl;
}

/** Payout multiplier as rep climbs — 1.0 → 1.5 across levels 0..5. */
export function repPayoutMultiplier(level: number): number {
	return 1 + level * 0.1;
}
